import SafetyAnchorPointListResourceListResultModel from '../../generated/types/model/resource/SafetyAnchorPointListResourceListResultModel';

export default class SafetyAnchorPointListResourceListResultViewModel extends SafetyAnchorPointListResourceListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
